function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#808080;}\n\t.st2{fill:#CDC366;}\n\t.st3{fill:#CEB866;}\n\t.st4{fill:#D0AC67;}\n\t.st5{fill:#D1A167;}\n\t.st6{fill:#D38B68;}\n\t.st7{fill:#D48068;}\n\t.st8{fill:#D67469;}\n\t.st9{fill:#D76969;}\n\t.st10{fill:#5CA97B;}\n\t.st11{fill:#6BA779;}\n\t.st12{fill:#7BA677;}\n\t.st13{fill:#8AA474;}\n\t.st14{fill:#A9A270;}\n\t.st15{fill:#B8A06E;}\n\t.st16{fill:#C89F6B;}\n\t.st17{fill:#D79D69;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M61.5,3.7h2.7l1.9,14.2h-2.6l-1.2-9.1L59,17.9h-2.4l-3.3-9.1l-1.2,9.1h-2.7l1.9-14.2h2.7l3.8,10.1L61.5,3.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M81.1,17.9h-2.7L77.2,15h-5.9l-1.1,2.9h-2.8l5.6-14.2h2.5L81.1,17.9z M72.3,12.3h3.8l-1.9-4.8L72.3,12.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M86.7,3.7c0.7,0,1.3,0.1,1.8,0.3c0.6,0.2,1,0.5,1.5,0.9c0.4,0.4,0.7,0.9,1,1.4c0.2,0.5,0.4,1.1,0.4,1.8 c0,0.6-0.1,1.2-0.3,1.8c-0.2,0.5-0.5,1-0.9,1.4s-0.9,0.7-1.5,0.9c-0.6,0.2-1.2,0.3-1.9,0.3h-1.5v5.4h-2.6V3.7H86.7z M85.2,6.5v3.3 h1.9c0.5,0,0.8-0.1,1.2-0.4s0.5-0.7,0.5-1.2c0-0.5-0.2-0.8-0.5-1.2s-0.7-0.5-1.2-0.5H85.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M102.1,17.6c-0.8,0.4-1.7,0.6-2.7,0.6s-1.8-0.2-2.7-0.6c-0.8-0.4-1.6-0.9-2.2-1.5c-0.6-0.7-1.1-1.4-1.5-2.3 s-0.6-1.9-0.6-2.9c0-1,0.2-2,0.6-2.9s0.9-1.7,1.5-2.3C95.2,5,96,4.4,96.8,4.1c0.8-0.4,1.7-0.6,2.7-0.6s1.8,0.2,2.7,0.6 c0.8,0.4,1.6,0.9,2.2,1.5c0.6,0.7,1.1,1.4,1.5,2.3s0.6,1.9,0.6,2.9c0,1-0.2,2-0.6,2.9s-0.9,1.7-1.5,2.3 C103.7,16.7,103,17.2,102.1,17.6z M101.6,5.6c-0.7-0.3-1.4-0.4-2.1-0.4S98,5.3,97.3,5.6s-1.2,0.7-1.7,1.2 c-0.5,0.5-0.9,1.1-1.1,1.8c-0.3,0.7-0.4,1.4-0.4,2.3c0,0.8,0.1,1.6,0.4,2.3c0.3,0.7,0.7,1.3,1.1,1.8c0.5,0.5,1.1,0.9,1.7,1.2 c0.7,0.3,1.4,0.4,2.1,0.4s1.5-0.1,2.1-0.4c0.7-0.3,1.2-0.7,1.7-1.2c0.5-0.5,0.9-1.1,1.1-1.8c0.3-0.7,0.4-1.4,0.4-2.3 c0-0.8-0.1-1.6-0.4-2.3c-0.3-0.7-0.7-1.3-1.1-1.8C102.9,6.3,102.3,5.9,101.6,5.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M108.4,3.7h7v1.6h-5.4v4.4h5.1v1.6h-5.1v6.5h-1.5V3.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M49.2,22.3h8.2v2.1l-5,9.3h5v2.8h-8.2v-2.1l4.9-9.3h-4.9V22.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M63.1,22.6c0.9-0.4,1.8-0.6,2.8-0.6c1,0,1.9,0.2,2.8,0.6s1.7,0.9,2.3,1.5c0.7,0.7,1.2,1.4,1.6,2.3 c0.4,0.9,0.6,1.9,0.6,3c0,1.1-0.2,2-0.6,2.9c-0.4,0.9-0.9,1.7-1.6,2.3c-0.7,0.7-1.4,1.2-2.3,1.5s-1.8,0.6-2.8,0.6 c-1,0-1.9-0.2-2.8-0.6c-0.9-0.4-1.7-0.9-2.3-1.5c-0.7-0.7-1.2-1.4-1.6-2.3c-0.4-0.9-0.6-1.9-0.6-2.9s0.2-2,0.6-2.9 c0.4-0.9,0.9-1.7,1.6-2.3C61.5,23.5,62.2,23,63.1,22.6z M67.8,25.2c-0.6-0.2-1.2-0.3-1.8-0.3s-1.3,0.1-1.8,0.3 c-0.6,0.2-1.1,0.5-1.5,0.9c-0.4,0.4-0.8,0.9-1,1.4c-0.2,0.6-0.4,1.2-0.4,1.9s0.1,1.3,0.4,1.9c0.2,0.6,0.6,1,1,1.4 c0.4,0.4,0.9,0.7,1.5,0.9c0.6,0.2,1.2,0.3,1.8,0.3s1.3-0.1,1.8-0.3c0.6-0.2,1.1-0.5,1.5-0.9s0.7-0.9,1-1.4 c0.2-0.6,0.4-1.2,0.4-1.9s-0.1-1.3-0.4-1.9c-0.2-0.6-0.6-1-1-1.4C68.8,25.7,68.3,25.4,67.8,25.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M75.5,22.3h2.6l6.6,9.6v-9.6h2.6v14.2h-2.6l-6.6-9.6v9.6h-2.6V22.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M90.4,22.3h7.8v2.8H93v2.7h4.6v2.8H93v3.1h5.2v2.8h-7.8V22.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M107.6,26.4c-0.4-0.5-0.9-0.8-1.5-1.1s-1.2-0.4-1.7-0.4c-0.2,0-0.3,0-0.5,0c-0.2,0-0.3,0.1-0.4,0.1 c-0.1,0.1-0.2,0.1-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0.1,0.4,0.3,0.7c0.2,0.2,0.4,0.4,0.6,0.6c0.6,0.4,1,0.8,1.5,1.2 c0.4,0.3,0.8,0.7,1.2,1c0.3,0.2,0.5,0.5,0.8,0.7c0.2,0.3,0.4,0.5,0.6,0.8c0.2,0.3,0.3,0.6,0.4,1c0.1,0.3,0.2,0.7,0.2,1.1 c0,0.6-0.1,1.2-0.3,1.6s-0.5,0.9-0.9,1.3c-0.4,0.3-0.8,0.6-1.4,0.8c-0.5,0.2-1.1,0.3-1.7,0.3c-0.5,0-1.1-0.1-1.5-0.2 s-0.9-0.3-1.3-0.6s-0.7-0.5-1-0.8s-0.5-0.6-0.6-0.9l0.8-2.4c0.2,0.3,0.5,0.6,0.8,0.8c0.3,0.3,0.6,0.5,0.9,0.7 c0.3,0.2,0.7,0.3,1,0.4s0.7,0.2,1,0.2c0.4,0,0.8-0.1,1.1-0.3c0.3-0.2,0.4-0.5,0.4-0.9c0-0.3-0.1-0.6-0.3-0.8 c-0.2-0.2-0.4-0.5-0.8-0.8c-0.7-0.6-1.3-1-1.8-1.5s-1-0.9-1.4-1.3c-0.4-0.4-0.7-0.8-1-1.3s-0.4-1-0.4-1.6c0-0.6,0.1-1.1,0.3-1.5 c0.2-0.4,0.5-0.8,0.8-1.1s0.8-0.5,1.2-0.7c0.5-0.2,1-0.2,1.5-0.2c0.4,0,0.8,0.1,1.2,0.2c0.4,0.1,0.7,0.3,1.1,0.4 c0.3,0.2,0.6,0.4,0.9,0.6c0.2,0.2,0.4,0.5,0.6,0.7L107.6,26.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  className: "st2",
  cx: 19.8,
  cy: 1.4,
  rx: 1.1,
  ry: 1.1
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st3",
  cx: 24.3,
  cy: 5.6,
  rx: 1.2,
  ry: 1.2
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st4",
  cx: 26.7,
  cy: 11.2,
  rx: 1.3,
  ry: 1.4
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st5",
  cx: 25.4,
  cy: 17.3,
  rx: 1.5,
  ry: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st6",
  cx: 14.7,
  cy: 23,
  rx: 1.7,
  ry: 1.8
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st7",
  cx: 13.3,
  cy: 28.8,
  rx: 1.9,
  ry: 1.9
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st8",
  cx: 15.4,
  cy: 34.6,
  rx: 2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "st9",
  cx: 19.8,
  cy: 38.9,
  rx: 2.1,
  ry: 2.2
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6987 -0.7154 0.7154 0.6987 5.2202 25.5807)",
  className: "st10",
  cx: 33,
  cy: 6.6,
  rx: 2.2,
  ry: 2.1
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6987 -0.7154 0.7154 0.6987 0.8715 27.6044)",
  className: "st11",
  cx: 33.2,
  cy: 12.8,
  rx: 2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6987 -0.7154 0.7154 0.6987 -3.8367 27.7133)",
  className: "st12",
  cx: 31,
  cy: 18.4,
  rx: 1.9,
  ry: 1.9
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6987 -0.7154 0.7154 0.6987 -7.8617 25.1147)",
  className: "st13",
  cx: 25.9,
  cy: 21.9,
  rx: 1.8,
  ry: 1.8
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6987 -0.7154 0.7154 0.6987 -8.9238 15.77)",
  className: "st14",
  cx: 14.3,
  cy: 18.5,
  rx: 1.6,
  ry: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6987 -0.7154 0.7154 0.6987 -12.7042 13.0688)",
  className: "st15",
  cx: 9.2,
  cy: 21.6,
  rx: 1.5,
  ry: 1.4
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6987 -0.7154 0.7154 0.6987 -17.5035 12.9082)",
  className: "st16",
  cx: 6.6,
  cy: 27.2,
  rx: 1.3,
  ry: 1.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6987 -0.7154 0.7154 0.6987 -21.8733 14.9178)",
  className: "st17",
  cx: 6.8,
  cy: 33.4,
  rx: 1.2,
  ry: 1.2
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9997 -2.367516e-02 2.367516e-02 0.9997 -0.4512 0.9226)",
  className: "st2",
  cx: 38.7,
  cy: 19.5,
  rx: 2.2,
  ry: 2.1
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9997 -2.367516e-02 2.367516e-02 0.9997 -0.5607 0.8256)",
  className: "st3",
  cx: 34.6,
  cy: 24.1,
  rx: 2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9997 -2.367516e-02 2.367516e-02 0.9997 -0.6211 0.6953)",
  className: "st4",
  cx: 29.1,
  cy: 26.6,
  rx: 1.9,
  ry: 1.9
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9997 -2.367516e-02 2.367516e-02 0.9997 -0.5974 0.5511)",
  className: "st5",
  cx: 23,
  cy: 25.5,
  rx: 1.8,
  ry: 1.8
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9997 -2.367516e-02 2.367516e-02 0.9997 -0.349 0.4077)",
  className: "st6",
  cx: 17,
  cy: 14.9,
  rx: 1.6,
  ry: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9997 -2.367516e-02 2.367516e-02 0.9997 -0.3194 0.2691)",
  className: "st7",
  cx: 11.2,
  cy: 13.6,
  rx: 1.4,
  ry: 1.4
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9997 -2.367516e-02 2.367516e-02 0.9997 -0.3733 0.1329)",
  className: "st8",
  cx: 5.4,
  cy: 15.8,
  rx: 1.3,
  ry: 1.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9997 -2.367516e-02 2.367516e-02 0.9997 -0.4827 3.513584e-02)",
  className: "st9",
  cx: 1.2,
  cy: 20.4,
  rx: 1.2,
  ry: 1.2
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6816 -0.7318 0.7318 0.6816 -13.2183 35.1968)",
  className: "st17",
  cx: 33.8,
  cy: 32.8,
  rx: 2.1,
  ry: 2.2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6816 -0.7318 0.7318 0.6816 -15.4562 30.8028)",
  className: "st16",
  cx: 27.7,
  cy: 33.2,
  rx: 2,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6816 -0.7318 0.7318 0.6816 -15.7399 25.9697)",
  className: "st15",
  cx: 22,
  cy: 31.1,
  rx: 1.9,
  ry: 1.9
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6816 -0.7318 0.7318 0.6816 -13.2171 21.7396)",
  className: "st14",
  cx: 18.4,
  cy: 26.1,
  rx: 1.7,
  ry: 1.8
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6816 -0.7318 0.7318 0.6816 -3.6552 20.3072)",
  className: "st13",
  cx: 21.5,
  cy: 14.4,
  rx: 1.4,
  ry: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6816 -0.7318 0.7318 0.6816 -1.018 16.3247)",
  className: "st12",
  cx: 18.2,
  cy: 9.3,
  rx: 1.3,
  ry: 1.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6816 -0.7318 0.7318 0.6816 -1.0283 11.3881)",
  className: "st11",
  cx: 12.6,
  cy: 6.9,
  rx: 1.2,
  ry: 1.2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.6816 -0.7318 0.7318 0.6816 -3.2523 6.9719)",
  className: "st10",
  cx: 6.4,
  cy: 7.2,
  rx: 1,
  ry: 1.1
}))), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 20,
  cy: 20.2,
  r: 1.7
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M6.7,50.7c-0.1,0.2-0.2,0.4-0.4,0.5c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.5,0.2-0.8,0.3C4.6,52,4.3,52,4,52 c-0.5,0-0.9-0.1-1.3-0.3S1.9,51.3,1.6,51s-0.6-0.7-0.7-1.1c-0.2-0.4-0.3-0.9-0.3-1.5c0-0.5,0.1-1,0.3-1.5c0.2-0.4,0.4-0.8,0.7-1.1 s0.7-0.6,1.1-0.7c0.4-0.2,0.9-0.3,1.3-0.3c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.1,0.4,0.3,0.6,0.4s0.3,0.3,0.4,0.5 l-0.3,0.8c-0.2-0.3-0.5-0.6-0.9-0.8c-0.4-0.2-0.8-0.3-1.4-0.3c-0.4,0-0.7,0.1-1,0.2s-0.6,0.3-0.8,0.5C2,46.7,1.8,47,1.7,47.3 c-0.1,0.3-0.2,0.7-0.2,1.1c0,0.4,0.1,0.8,0.2,1.1c0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.5s0.7,0.2,1,0.2 c0.6,0,1-0.1,1.4-0.3c0.4-0.2,0.7-0.5,0.9-0.8L6.7,50.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12,48.5c0.1,0.3,0.2,0.6,0.2,1s-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.5,0.8c-0.2,0.2-0.5,0.4-0.8,0.5 C10.4,52,10.1,52,9.8,52S9.1,52,8.8,51.8c-0.3-0.1-0.6-0.3-0.8-0.5c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.6-0.2-1s0.1-0.7,0.2-1 c0.1-0.3,0.3-0.6,0.5-0.8c0.2-0.2,0.5-0.4,0.8-0.5s0.6-0.2,0.9-0.2s0.6,0.1,0.9,0.2s0.6,0.3,0.8,0.5C11.7,47.9,11.9,48.2,12,48.5z  M8.2,49.5c0,0.2,0,0.5,0.1,0.7c0.1,0.2,0.2,0.4,0.3,0.5C8.8,50.8,9,50.9,9.1,51c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.6-0.1 s0.4-0.2,0.5-0.3c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.7s0-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.3-0.5 c-0.1-0.1-0.3-0.3-0.5-0.3c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1,0.1-0.3,0.3-0.3,0.5 C8.2,49,8.2,49.2,8.2,49.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M14.1,49.6c-0.3-0.2-0.6-0.4-0.8-0.6s-0.3-0.5-0.3-0.8c0-0.4,0.1-0.7,0.4-1s0.6-0.4,1.1-0.4 c0.2,0,0.3,0,0.5,0.1c0.1,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.2,0.2l-0.1,0.8c-0.2-0.2-0.4-0.3-0.6-0.4 c-0.2-0.1-0.4-0.1-0.7-0.1c-0.2,0-0.3,0-0.4,0.1C14.1,48,14,48.1,14,48.3c0,0.1,0.1,0.2,0.2,0.3s0.2,0.2,0.4,0.2l0.5,0.3 c0.4,0.2,0.7,0.4,0.9,0.6c0.2,0.2,0.3,0.5,0.3,0.8c0,0.2,0,0.4-0.1,0.6s-0.2,0.3-0.3,0.5s-0.3,0.2-0.5,0.3C15,52,14.8,52,14.5,52 c-0.2,0-0.4,0-0.5-0.1c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.2-0.3l0.2-0.7c0.2,0.2,0.4,0.4,0.6,0.5 c0.2,0.1,0.5,0.2,0.8,0.2c0.1,0,0.2,0,0.3,0s0.2,0,0.2-0.1c0.1,0,0.1-0.1,0.2-0.2c0-0.1,0.1-0.1,0.1-0.2c0-0.1-0.1-0.3-0.2-0.4 s-0.3-0.2-0.5-0.3L14.1,49.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M19.6,46.9c0.3,0,0.6,0.1,0.9,0.2s0.5,0.3,0.7,0.6c0.2-0.2,0.4-0.4,0.7-0.6c0.3-0.1,0.6-0.2,1-0.2 c0.2,0,0.5,0,0.7,0.1c0.2,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.4,0.4,0.5,0.7c0.1,0.3,0.2,0.6,0.2,1v2.8H24v-2.8c0-0.2,0-0.4-0.1-0.5 c-0.1-0.2-0.1-0.3-0.3-0.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.2-0.2,0.4v3.1h-0.9v-2.8c0-0.2,0-0.4-0.1-0.5c-0.1-0.2-0.1-0.3-0.3-0.4 c-0.1-0.1-0.2-0.2-0.4-0.2s-0.3-0.1-0.5-0.1c-0.1,0-0.3,0-0.4,0.1s-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3s-0.1,0.2-0.2,0.4v3.1 h-0.9V47h0.9v0.5c0.1-0.2,0.2-0.3,0.5-0.5S19.2,46.9,19.6,46.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M30.6,48.5c0.1,0.3,0.2,0.6,0.2,1s-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.5,0.8c-0.2,0.2-0.5,0.4-0.8,0.5 C29,52,28.7,52,28.4,52s-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.3-0.8-0.5c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.6-0.2-1s0.1-0.7,0.2-1 c0.1-0.3,0.3-0.6,0.5-0.8c0.2-0.2,0.5-0.4,0.8-0.5s0.6-0.2,0.9-0.2s0.6,0.1,0.9,0.2s0.6,0.3,0.8,0.5C30.3,47.9,30.5,48.2,30.6,48.5 z M26.8,49.5c0,0.2,0,0.5,0.1,0.7c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.6-0.1 s0.4-0.2,0.5-0.3c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.7s0-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.3-0.5 c-0.1-0.1-0.3-0.3-0.5-0.3c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1,0.1-0.3,0.3-0.3,0.5 C26.8,49,26.8,49.2,26.8,49.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M32.7,49.6c-0.3-0.2-0.6-0.4-0.8-0.6c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.4,0.1-0.7,0.4-1c0.3-0.2,0.6-0.4,1.1-0.4 c0.2,0,0.3,0,0.5,0.1c0.1,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.2,0.2l-0.1,0.8c-0.2-0.2-0.4-0.3-0.6-0.4 c-0.2-0.1-0.4-0.1-0.7-0.1c-0.2,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0.1,0.2,0.2,0.3s0.2,0.2,0.4,0.2l0.5,0.3 c0.4,0.2,0.7,0.4,0.9,0.6s0.3,0.5,0.3,0.8c0,0.2,0,0.4-0.1,0.6s-0.2,0.3-0.3,0.5s-0.3,0.2-0.5,0.3C33.6,52,33.4,52,33.1,52 c-0.2,0-0.4,0-0.5-0.1c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.2-0.3l0.2-0.7c0.2,0.2,0.4,0.4,0.6,0.5 c0.2,0.1,0.5,0.2,0.8,0.2c0.1,0,0.2,0,0.3,0s0.2,0,0.2-0.1c0.1,0,0.1-0.1,0.2-0.2c0-0.1,0.1-0.1,0.1-0.2c0-0.1-0.1-0.3-0.2-0.4 s-0.3-0.2-0.5-0.3L32.7,49.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M40.5,46.9c0.3,0,0.5,0,0.8,0.1c0.3,0.1,0.5,0.2,0.7,0.4s0.4,0.4,0.5,0.7c0.1,0.3,0.2,0.6,0.2,1v2.7h-0.9v-2.7 c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4S41.1,48,41,48c-0.1-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.3,0-0.4,0.1 c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3s-0.1,0.2-0.2,0.4v3.1h-0.9V47h0.9v0.5c0.1-0.2,0.2-0.3,0.4-0.5 C39.9,47,40.1,46.9,40.5,46.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M46.3,51.1c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.2 l0.2,0.7c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.3,0.2-0.5,0.2C46.7,52,46.4,52,46.2,52 c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.5c-0.2-0.2-0.4-0.5-0.5-0.8s-0.2-0.7-0.2-1.1c0-0.3,0.1-0.7,0.2-1s0.3-0.6,0.5-0.8 c0.2-0.2,0.5-0.4,0.7-0.6s0.6-0.2,1-0.2c0.4,0,0.7,0.1,0.9,0.2c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.5,0.5,0.8 c0.1,0.3,0.2,0.6,0.2,1c0,0.1,0,0.2,0,0.3h-3.7c0,0.4,0.2,0.7,0.5,1C45.4,51,45.8,51.1,46.3,51.1z M47.4,48.9 c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.3,0-0.5,0.1 c-0.2,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.2,0.4H47.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M52.5,51.4c-0.1,0.2-0.2,0.3-0.4,0.4C51.8,52,51.6,52,51.3,52c-1,0-1.5-0.5-1.5-1.6V48h-0.9v-0.3l1.5-1.9h0.3 V47h1.7V48h-1.7v2.2c0,0.3,0.1,0.5,0.2,0.7s0.3,0.2,0.6,0.2c0.2,0,0.3,0,0.5-0.1c0.1-0.1,0.2-0.2,0.3-0.3L52.5,51.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M58.7,50.7l1.4-3.6h1l-1.9,4.9h-0.9l-1.2-3.7l-1.2,3.7H55L53.1,47h0.9l1.4,3.6l1.2-3.6h0.9L58.7,50.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M66.2,48.5c0.1,0.3,0.2,0.6,0.2,1s-0.1,0.7-0.2,1s-0.3,0.6-0.5,0.8s-0.5,0.4-0.8,0.5C64.6,52,64.2,52,63.9,52 c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.3-0.8-0.5s-0.4-0.5-0.5-0.8s-0.2-0.6-0.2-1s0.1-0.7,0.2-1s0.3-0.6,0.5-0.8 c0.2-0.2,0.5-0.4,0.8-0.5c0.3-0.1,0.6-0.2,0.9-0.2c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.6,0.3,0.8,0.5C65.9,47.9,66,48.2,66.2,48.5z  M62.3,49.5c0,0.2,0,0.5,0.1,0.7c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.6-0.1 c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.7s0-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.3-0.5 c-0.1-0.1-0.3-0.3-0.5-0.3c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1,0.1-0.3,0.3-0.3,0.5 C62.4,49,62.3,49.2,62.3,49.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M70.1,48.1C70.1,48,70,48,69.9,47.9c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.3,0.2 s-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.3v3.1h-0.9V47h0.9v0.6c0.1-0.2,0.2-0.4,0.4-0.5c0.2-0.1,0.4-0.2,0.7-0.2 c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.3,0.2,0.3,0.3L70.1,48.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M71.2,44.8h0.9V49l2.1-2h1.2l-2.5,2.3l2.7,2.6h-1.3l-2.3-2.2v2.2h-0.9V44.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M80.9,51.1c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.2 l0.2,0.7c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.3,0.2-0.5,0.2C81.3,52,81.1,52,80.9,52 c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.5s-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.7-0.2-1.1c0-0.3,0.1-0.7,0.2-1s0.3-0.6,0.5-0.8 c0.2-0.2,0.5-0.4,0.8-0.6s0.6-0.2,1-0.2c0.4,0,0.7,0.1,0.9,0.2c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.5,0.5,0.8 c0.1,0.3,0.2,0.6,0.2,1c0,0.1,0,0.2,0,0.3h-3.7c0,0.4,0.2,0.7,0.5,1C80.1,51,80.4,51.1,80.9,51.1z M82,48.9c0-0.1-0.1-0.3-0.1-0.4 s-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.3,0-0.5,0.1c-0.2,0.1-0.3,0.1-0.4,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.2,0.4H82z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M84.4,51.9h-1.1l1.8-2.6L83.5,47h1.1l1.1,1.5l1.1-1.5h1.1l-1.6,2.3l1.8,2.6H87l-1.3-1.8L84.4,51.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M93.5,48.4c0.1,0.3,0.2,0.7,0.2,1s-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.5,0.8c-0.2,0.2-0.5,0.4-0.8,0.5 C91.9,52,91.6,52,91.3,52c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.4-0.3-0.5-0.5V54h-0.9V47h0.9v0.5c0.1-0.2,0.3-0.3,0.5-0.5 s0.6-0.2,1-0.2c0.3,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.8,0.5C93.2,47.9,93.4,48.1,93.5,48.4z M92.9,49.5c0-0.5-0.1-0.9-0.4-1.2 c-0.3-0.3-0.7-0.4-1.2-0.4c-0.3,0-0.6,0.1-0.9,0.2s-0.4,0.3-0.5,0.6v1.6c0.1,0.2,0.3,0.4,0.5,0.6s0.6,0.2,0.9,0.2 c0.5,0,0.9-0.1,1.2-0.4S92.9,49.9,92.9,49.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M94.9,44.8h0.9v7.1h-0.9V44.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M101.6,48.5c0.1,0.3,0.2,0.6,0.2,1s-0.1,0.7-0.2,1s-0.3,0.6-0.5,0.8s-0.5,0.4-0.8,0.5C100,52,99.7,52,99.4,52 c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.3-0.8-0.5s-0.4-0.5-0.5-0.8s-0.2-0.6-0.2-1s0.1-0.7,0.2-1s0.3-0.6,0.5-0.8 c0.2-0.2,0.5-0.4,0.8-0.5c0.3-0.1,0.6-0.2,0.9-0.2c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.6,0.3,0.8,0.5 C101.3,47.9,101.5,48.2,101.6,48.5z M97.8,49.5c0,0.2,0,0.5,0.1,0.7c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.1,0.3,0.2,0.5,0.3 c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.3-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.7 s0-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.1-0.3-0.3-0.5-0.3c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.6,0.1 c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1,0.1-0.3,0.3-0.3,0.5C97.8,49,97.8,49.2,97.8,49.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M105.6,48.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.3,0.2 s-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.3v3.1H103V47h0.9v0.6c0.1-0.2,0.2-0.4,0.4-0.5c0.2-0.1,0.4-0.2,0.7-0.2 c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.3,0.2,0.3,0.3L105.6,48.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M108.8,51.1c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.2 l0.2,0.7c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.6,0.1 c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.5s-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.7-0.2-1.1c0-0.3,0.1-0.7,0.2-1s0.3-0.6,0.5-0.8 c0.2-0.2,0.5-0.4,0.8-0.6s0.6-0.2,1-0.2c0.4,0,0.7,0.1,0.9,0.2c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.5,0.5,0.8 c0.1,0.3,0.2,0.6,0.2,1c0,0.1,0,0.2,0,0.3h-3.7c0,0.4,0.2,0.7,0.5,1C108,51,108.4,51.1,108.8,51.1z M110,48.9 c0-0.1-0.1-0.3-0.1-0.4s-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.3,0-0.5,0.1 c-0.2,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.2,0.4H110z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M114.7,48.1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.3,0.2 s-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.1,0.3v3.1H112V47h0.9v0.6c0.1-0.2,0.2-0.4,0.4-0.5c0.2-0.1,0.4-0.2,0.7-0.2 c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.3,0.2,0.3,0.3L114.7,48.1z"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.8 54.3",
    style: {
      enableBackground: "new 0 0 115.8 54.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.bb17a6d1.svg";
export { ForwardRef as ReactComponent };